import { render, staticRenderFns } from "./brand-ex-module2.vue?vue&type=template&id=2b08cffc&scoped=true"
import script from "./brand-ex-module2.vue?vue&type=script&lang=js"
export * from "./brand-ex-module2.vue?vue&type=script&lang=js"
import style0 from "./brand-ex-module2.vue?vue&type=style&index=0&id=2b08cffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08cffc",
  null
  
)

export default component.exports